export * from './IconComponent';
export * from './ColorComponent';
